


















































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import ResponsiveImage from 'frontend/components/ResponsiveImage.vue';
import { MobileGetter, ExperimentGetter, User } from 'frontend/types';

@Component({
  components: {
    ResponsiveImage,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('globals', ['inExperiment']),
    ...mapState('globals', ['user']),
    ...mapGetters('paywall', ['trialLength']),
  },
})
export default class CourseContents extends Vue {
  private isMobile!: MobileGetter;
  private inExperiment!: ExperimentGetter;
  private user!: User;
  private useMobileStyles = false;
  private readonly trialLength!: number;

  @Prop(Boolean) private readonly onTrialPaywall!: boolean | undefined;

  private get twoPageGroup(): boolean {
    return !this.user.one_page_trial_paywall;
  }

  private onResize() {
    this.useMobileStyles = document.body.clientWidth <= 960;
  }

  private mounted() {
    if (this.isMobile(this.$mq)) {
      this.useMobileStyles = true;
    } else {
      this.onResize();
      window.addEventListener('resize', this.onResize);
    }
  }

  private destroyed() {
    window.removeEventListener('resize', this.onResize);
  }
}
